import { format } from "date-fns";
import { FC, memo } from "react";
import { Link } from "react-router-dom";
import { AllClaimsTypeProps } from "src/pages/actionDashboard/types";

const AllClaimsTableRow: FC<{ treatable: AllClaimsTypeProps; refreshListing: () => void; }> = ({ treatable }): JSX.Element => {
    const formatDate = (date: string) => (date ? format(new Date(date), "MM/dd/yyyy") : "");
  
  return (
    <>
      <tr>
        <td className="text-center align-middle case-td">
          <Link
            to={{ pathname: `/cases/detail/${treatable.case_id}` }}
            className={`${'text-zilretta'} `}>
            {treatable.case_id}
          </Link>
        </td>
        <td className="text-center align-middle">
           {treatable && treatable.submitted_date ? formatDate(treatable.submitted_date) : "" } 
        </td>
        <td className="text-center align-middle">
          {treatable.patient_name}
        </td>
        <td className="text-center align-middle">
          {treatable.product}
        </td>
        <td className="text-center align-middle">
          {treatable.submitting_practice}
        </td>
        <td className="text-center align-middle">
          <span className={`badge background-color-2`}>
            {treatable.status}
          </span>
        </td>
        <td className="text-center align-middle">
          {treatable.copay}
        </td>
       {treatable.next_step ? <td className="text-center align-middle">
          <Link to={`/cases/${treatable.case_id}/copay`} className="btn btn-copay btn-sm">Copay Claim</Link>
        </td> : <td className="text-center align-middle">No Action Required</td>}
        <td
          className={`text-center align-middle ${treatable.days_left < 40 ? "text-danger" : ""}`}
        >
          {treatable.days_left ?? "N/A"}
        </td>
      </tr>
    </>
  )
}

export default memo(AllClaimsTableRow);
